export const Sprig = ({ className = "" }) => (
    <svg viewBox="0 0 100 160" fill="none" className={className} aria-hidden="true">
        <path d="M50 155 C48 120 46 80 52 15" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M50 120 C38 112 30 100 30 88 C42 94 48 106 50 120Z" fill="currentColor" opacity=".5" />
        <path d="M51 96 C62 90 68 78 67 66 C56 72 52 84 51 96Z" fill="currentColor" opacity=".35" />
        <path d="M50 70 C40 64 35 54 36 44 C46 50 49 60 50 70Z" fill="currentColor" opacity=".4" />
        <circle cx="53" cy="11" r="4" fill="currentColor" opacity=".6" />
    </svg>
);

export const Mark = ({ className = "" }) => (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
        <rect width="64" height="64" rx="16" fill="#4A1227" />
        <circle cx="26" cy="32" r="11" fill="none" stroke="#F7EBEB" strokeWidth="2.4" />
        <circle cx="40" cy="32" r="11" fill="none" stroke="#C5A059" strokeWidth="2.4" />
        <circle cx="33" cy="32" r="2.6" fill="#C5A059" />
    </svg>
);

export const Divider = ({ className = "" }) => (
    <div className={`flex items-center justify-center gap-3 ${className}`} aria-hidden="true">
        <span className="h-px w-12 bg-gold/50" />
        <Sprig className="h-8 w-5 text-gold/70" />
        <span className="h-px w-12 bg-gold/50" />
    </div>
);
